<template>
  <div class="pdp-additional-product-container">
    <div class="display-m headline-sm-l text-center mb-sm-6">
      <div class="pb-2">{{ title }}</div>
    </div>

    <div v-if="desc" class="pdp-river-content-desc">
      {{ desc }}
    </div>

    <div class="product-swiper-container">
      <swiper
        :ref="keyProducts"
        class="swiper swiper-slide-container"
        :options="swiperOptions"
        @slideChange="onSwiperSlideChange"
      >
        <swiper-slide
          v-for="(item, index) in items"
          :key="`${keyProducts}-${item.id}`"
          :class="`slide-product-${keyProducts}-${index}`"
        >
          <div :key="item.id" class="pdp-additional-product-item">
            <ProductCardItem
              :type="'tile'"
              :item="item"
              @toggle="$emit('toggle', item)"
            />
          </div>
        </swiper-slide>
      </swiper>
      <div
        :class="`swiper-pagination-${keyProducts} swiper-pagination`"
      ></div>
      <v-btn
        v-if="items.length > 3"
        :color="isBnn ? 'secondary' : 'primary'"
        depressed
        :class="
          `swiper-product-button-prev swiper-product-button-${keyProducts}-prev swiper-product-button`
        "
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        v-if="items.length > 3"
        :color="isBnn ? 'secondary' : 'primary'"
        depressed
        :class="
          `swiper-product-button-next swiper-product-button-${keyProducts}-next swiper-product-button`
        "
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import isBnn from '@/config/isBnn'

export default {
  name: 'PDPProductAlsoBought',

  components: {
    ProductCardItem: () =>
      import('@/components/studio7/ProductCardItem.vue'),
  },

  props: {
    keyProducts: {
      type: String,
      default: '0',
    },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    items: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs[this.keyProducts].$swiper.update()
    })
  },

  computed: {
    swiper() {
      return this.$refs[this.keyProducts].swiper
    },
  },

  data() {
    return {
      isBnn,
      swiperOptions: {
        threshold: 16,
        spaceBetween: 32,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        slidesOffsetBefore: 1,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesOffsetBefore: 60,
            spaceBetween: 60,
          },
          1024: {
            slidesPerView: 'auto',
            slidesOffsetBefore: 1,
            spaceBetween: 60,
          },
          1280: {
            slidesPerView: 3,
            slidesOffsetBefore: 1,
            spaceBetween: 60,
          },
        },
        pagination: {
          el: `.swiper-pagination-${this.keyProducts}`,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        navigation: {
          nextEl: `.swiper-product-button-${this.keyProducts}-next`,
          prevEl: `.swiper-product-button-${this.keyProducts}-prev`,
        },
      },

      isDesktop: true,
      activeVideoRef: null,
      activeIndex: 1,
    }
  },
}
</script>

<style lang="stylus" scoped>
.pdp-additional-product-container {
    padding: 32px 0
    max-width: 1200px

    @media screen and (min-width: 768px) {
        padding: 32px 12px
    }
}

.pdp-additional-product-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
    gap: 16px;
    align-items: flex-start;
    justify-content: center;
    padding: 16px 16px 3.125rem;
    background-color: #f7f7f7;
    border-radius: .5rem;

    @media screen and (min-width: 1024px) {
      flex-direction: row;
      flex-wrap: wrap;
      padding: 16px 16px 3.125rem;
    }

  .pdp-additional-product-item {
    width: 100%;
    flex-basis: 100%;

    @media screen and (min-width: 768px) {
      width: 25%;
      flex-basis: 25%;
    }
  }
}

.pdp-additional-product-action {
    display: flex;
    justify-content: center;
    transform: translateY(-50%);

    .v-btn {
      width: fit-content

      @media screen and (min-width: 768px) {
      width: 100%;
      }
    }
}

.pdp-product-tile-layout {
    display: flex;
    flex-direction: column;
    gap: 60px;
    grid-gap: 60px;
    align-items: flex-start;
    justify-content: center;
    padding: 16px 16px 3.125rem;

    @media screen and (min-width: 1024px) {
      flex-direction: row;
      flex-wrap: wrap;
      padding: 16px 16px 3.125rem;
    }

  .pdp-additional-product-item {
    width: 100%;
    flex-basis: 100%;

    @media screen and (min-width: 768px) {
      // width: 25%;
      // flex-basis: 25%;
    }
  }
}

.v-btn.swiper-product-button{
    transition: all .15s ease;
    font-size: 1.375rem;
    height: 3rem !important;
    width: 3rem !important;
    margin-top: 0 !important;
    transform: translateY(-50%);
    border-radius: 50% !important;
    background-color: #0071e3;
    color: #fff !important;
    padding: 0 !important;
    min-width: 3rem !important;

    position absolute
    top 34%

    z-index 10
}
.swiper-slide-container{
    max-width 996px
    padding 8px 2px 26px

    @media screen and (min-width: 768px) {
        padding 0
    }
}
.product-swiper-container {
    position: relative;
    width: 100%;
    padding: 0

    @media screen and (min-width: 1024px) {
        padding: 0 64px
    }

    .swiper-product-button-prev {
      left: -6px;
      display: none;
        @media screen and (min-width: 1024px) {
            display: block;
        }
    }

    .swiper-product-button-next {
        right: -6px;
        display: none;

        @media screen and (min-width: 1024px) {
            display: block;
        }
    }
}

.swiper-pagination {
    position: static !important;
    display: flex;
    justify-content: center;
    grid-gap: 1rem;
    gap: 1rem;
    margin-top: 2rem;
    padding: .5rem 0;
}

::v-deep {
    .swiper-slide {
        width: fit-content !important;
    }

    .swiper-pagination-bullet {
        width: 12px !important;
        height: 12px !important;
        opacity: 1 !important;
        background-color: #d0d0d0 !important;
        border-radius: 50% !important;
        transition: width .3s, background-color .3s;
    }

    .swiper-pagination-bullet-active {
        background-color: #969696 !important
    }

	.swiper-button-disabled {
		opacity: 0.25 !important;
		pointer-events: none;
		cursor: auto;
	}
}
</style>
